
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facetime",
      function () {
        return require("private-next-pages/facetime/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/facetime"])
      });
    }
  